/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../../app/modules/auth'
import { StepProps } from '../IAppModels'

const Step1 = ({
  data,
  updateData,
  hasError,
  onValidationChange,
  claimDetails,
}: StepProps & {onValidationChange: (isValid: boolean) => void}) => {
  const user = useAuth()
  const {auth} = useAuth()
  const {formatMessage: f} = useIntl()
  const [icdData, setIcdData] = useState([])
  const [icdData2, setIcdData2] = useState([])
  const [icdData3, setIcdData3] = useState([])
  const [icdData4, setIcdData4] = useState([])
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [dropdownVisible2, setDropdownVisible2] = useState(false)
  const [dropdownVisible3, setDropdownVisible3] = useState(false)
  const [dropdownVisible4, setDropdownVisible4] = useState(false)

  // File upload states
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [fileErrors, setFileErrors] = useState<string[]>([])
  const [uploadProgress, setUploadProgress] = useState<number>(0)
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [successMessage, setSuccessMessage] = useState<string>('')

  const jsonString = claimDetails?.claimDetails?.claim?.detailBenefit
  const parsedJson = jsonString ? JSON.parse(jsonString) : {}

  const parsedMemberDetail = claimDetails.claimDetails?.claim?.memberDetail
    ? JSON.parse(claimDetails.claimDetails?.claim?.memberDetail)
    : {}
  const [productCode, setProductCode] = useState<string>('')
  const [isProductCodeLoaded, setIsProductCodeLoaded] = useState<boolean>(false)

  const [hoveredInput, setHoveredInput] = useState('')

  const getInputStyle = (inputName: string) => {
    return {
      backgroundColor: 'white',
      border: '1px solid #e4e6ef',
      transition: 'all 0.3s ease',
      ...(hoveredInput === inputName && {
        borderColor: '#059BB6',
        boxShadow: '0 0 5px rgba(5, 155, 182, 0.5)',
      }),
    }
  }

  console.log('Token Step1: ', user.currentUser?.token)

  const fetchIcdData = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        console.log(`Fetched data for ${identifier}:`, data)
        setIcdData(data)
        setDropdownVisible(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData2 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        console.log(`Fetched data for ${identifier}:`, data)
        setIcdData2(data)
        setDropdownVisible2(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData3 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        setIcdData3(data)
        setDropdownVisible3(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const fetchIcdData4 = useCallback(
    debounce(async (identifier, searchTerm) => {
      if (searchTerm.length <= 2 || !productCode) return

      const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Exclusion/GetPaginatedMstIcd10s?searchTerm=${searchTerm}&pageNumber=1&pageSize=10&productCode=${productCode}&planCode=${parsedJson.PlanCode}&benefitCode=${parsedJson.BenefitCode}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        const data = response.data.data || []
        setIcdData4(data)
        setDropdownVisible4(data.length > 0)
      } catch (err) {
        console.error('Error fetching ICD-10 data:', err)
      }
    }, 300),
    [productCode, auth?.token, user.currentUser?.token, parsedJson.PlanCode, parsedJson.BenefitCode]
  )

  const handleInputChange = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData(identifier, value)
  }

  const handleInputChange2 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData2(identifier, value)
  }

  const handleInputChange3 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData3(identifier, value)
  }

  const handleInputChange4 = (identifier, e) => {
    const {value} = e.target
    updateData({
      appBasic: {
        ...data.appBasic,
        [identifier]: value,
      },
    })
    fetchIcdData4(identifier, value)
  }

  const handleSelectIcd = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd10: selectedValue,
      },
    })
    setIcdData([])
    setDropdownVisible(false)
  }

  const handleSelectIcd2 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd102: selectedValue,
      },
    })
    setIcdData2([])
    setDropdownVisible2(false)
  }

  const handleSelectIcd3 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd103: selectedValue,
      },
    })
    setIcdData3([])
    setDropdownVisible3(false)
  }

  const handleSelectIcd4 = (icd: any) => {
    const selectedValue = `${icd.code} - ${icd.name}`
    updateData({
      appBasic: {
        ...data.appBasic,
        icd104: selectedValue,
      },
    })
    setIcdData4([])
    setDropdownVisible4(false)
  }

  const fetchMemberDetail = async () => {
    const apiUrl = `${process.env.REACT_APP_API_USER_URL}/api/Data/Provider/GetMemberByCard?ProviderCode=${user.currentUser?.providerCode}&CardNo=${parsedMemberDetail?.CardNumber}&Dob=${parsedMemberDetail?.DateOfBirth}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }
    try {
      const response = await axios.get(apiUrl, {headers})
      if (response.data.isSuccess) {
        const productCodeData = response.data.data.productCode
        setProductCode(productCodeData)
        setIsProductCodeLoaded(true)
        console.log('Product code set:', productCodeData)
      }
    } catch (err) {
      console.error('Error fetching member detail:', err)
      setIsProductCodeLoaded(true)
    }
  }

  useEffect(() => {
    fetchMemberDetail()
  }, [])

  useEffect(() => {
    const isValid = validateData()
    onValidationChange(isValid)
  }, [data, selectedFiles, onValidationChange])

  const validateData = () => {
    // Require ICD-10 (1) AND at least one uploaded file
    return (data?.appBasic?.icd10 ?? '').toString().trim() !== '' && selectedFiles.length > 0
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  // File upload handlers
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (!files) return

    const newFiles: File[] = Array.from(files)
    const errors: string[] = []

    newFiles.forEach((file) => {
      if (file.size > 10 * 1024 * 1024) {
        errors.push(f({id: 'CLAIM.OUTPATIENT.VALIDATION_LARGE_FILE'}, {fileName: file.name}))
      }
      const fileType = file.name.split('.').pop()?.toLowerCase()
      if (!['docx', 'pdf'].includes(fileType || '')) {
        errors.push(f({id: 'CLAIM.OUTPATIENT.VALIDATION_FILE_TYPE'}, {fileName: file.name}))
      }
    })

    if (errors.length > 0) {
      setFileErrors(errors)
      return
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles])
    setFileErrors([])

    updateData({
      appFiles: {
        ...data.appFiles,
        files: [...selectedFiles, ...newFiles],
      },
    })

    uploadFiles(newFiles)
  }

  const uploadFiles = async (filesToUpload: File[]) => {
    if (filesToUpload.length === 0) return

    setIsUploading(true)
    setUploadProgress(0)
    setSuccessMessage('')

    let progress = 0
    const interval = setInterval(() => {
      progress += 5
      setUploadProgress(progress)

      if (progress >= 100) {
        clearInterval(interval)
        setIsUploading(false)
        setSuccessMessage('Files uploaded successfully!')
        setTimeout(() => {
          setSuccessMessage('')
        }, 3000)
      }
    }, 200)
  }

  const removeFile = (index: number) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index)
    setSelectedFiles(updatedFiles)

    updateData({
      appFiles: {
        ...data.appFiles,
        files: updatedFiles,
      },
    })
  }

  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* ICD-10 Input Fields */}
        <div className='fv-row mb-10'>
          <label className='form-label required'>{f({id: 'CLAIM.INPATIENT.ICD10_CODE'})} </label>
          <div style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10...'
              value={data.appBasic.icd10 || ''}
              onChange={(e) => handleInputChange('icd10', e)}
              onFocus={() => setDropdownVisible(icdData.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd10')}
              onMouseEnter={() => setHoveredInput('icd10')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible && icdData.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className='fv-row mb-10'>
          <label className='form-label'>{f({id: 'CLAIM.INPATIENT.ICD10_CODE'})} (2) </label>
          <div style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (2)...'
              value={data.appBasic.icd102 || ''}
              onChange={(e) => handleInputChange2('icd102', e)}
              onFocus={() => setDropdownVisible2(icdData2.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd102')}
              onMouseEnter={() => setHoveredInput('icd102')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible2 && icdData2.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData2.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd2(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className='fv-row mb-10'>
          <label className='form-label'>{f({id: 'CLAIM.INPATIENT.ICD10_CODE'})} (3) </label>
          <div style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (3)...'
              value={data.appBasic.icd103 || ''}
              onChange={(e) => handleInputChange3('icd103', e)}
              onFocus={() => setDropdownVisible3(icdData3.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd103')}
              onMouseEnter={() => setHoveredInput('icd103')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible3 && icdData3.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData3.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd3(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className='fv-row mb-10'>
          <label className='form-label'>{f({id: 'CLAIM.INPATIENT.ICD10_CODE'})} (4) </label>
          <div style={{position: 'relative'}}>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Search ICD-10 (4)...'
              value={data.appBasic.icd104 || ''}
              onChange={(e) => handleInputChange4('icd104', e)}
              onFocus={() => setDropdownVisible4(icdData4.length > 0)}
              onKeyDown={handleKeyDown}
              style={getInputStyle('icd104')}
              onMouseEnter={() => setHoveredInput('icd104')}
              onMouseLeave={() => setHoveredInput('')}
            />
            {dropdownVisible4 && icdData4.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  width: '100%',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              >
                {icdData4.map((icd: any, index: number) => (
                  <div
                    key={index}
                    className='dropdown-item'
                    onClick={() => handleSelectIcd4(icd)}
                    style={{padding: '8px 12px', cursor: 'pointer'}}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {icd.code} - {icd.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* File Upload Section - MANDATORY */}
        <div className='fv-row mb-10'>
          <label className='form-label required'>{f({id: 'CLAIM.INPATIENT.UPLOAD_DOCUMENTS'})} </label>
          {hasError && selectedFiles.length === 0 && (
            <div className='text-danger fs-7 mb-2'>
              <i className='fas fa-exclamation-circle me-1'></i>
              Upload document is required
            </div>
          )}
          <div className='border-dashed p-4'>
            <div className='d-flex flex-column'>
              {/* Upload Area */}
              <div
                className='upload-area mb-3 p-4 border-dashed d-flex flex-column align-items-center justify-content-center'
                style={{
                  minHeight: '150px',
                  backgroundColor: hasError && selectedFiles.length === 0 ? '#fff5f5' : '#f8f9fa',
                  cursor: 'pointer',
                  position: 'relative',
                  border: hasError && selectedFiles.length === 0 ? '2px dashed #f1416c' : '2px dashed #dee2e6',
                  borderRadius: '8px',
                }}
              >
                <i className='fas fa-upload fs-2x mb-3'></i>
                <span className='text-muted mb-2'>
                  {f({id: 'CLAIM.INPATIENT.MAXIMUM_FILE_SIZE_2MB'})}
                </span>
                <input
                  type='file'
                  className='form-control form-control-lg form-control-solid'
                  name='uploadDocuments'
                  onChange={handleFileChange}
                  accept='.docx,.pdf'
                  multiple
                  style={{
                    opacity: 0,
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2,
                  }}
                />
                <button className='btn btn-sm btn-light-primary' style={{zIndex: 1}}>
                  {f({id: 'CLAIM.INPATIENT.CHOOSE_FILES'})}
                </button>
              </div>

              {/* Upload Progress Bar */}
              {isUploading && (
                <div
                  className='mb-3 p-4'
                  style={{
                    background: 'white',
                    padding: '16px',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    border: '1px solid #e9ecef',
                  }}
                >
                  <div
                    style={{
                      marginBottom: '10px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#059BB6',
                        fontWeight: 500,
                      }}
                    >
                      <Spinner
                        animation='border'
                        size='sm'
                        style={{
                          marginRight: '8px',
                          color: '#059BB6',
                          width: '16px',
                          height: '16px',
                        }}
                      />
                      {f({id: 'CLAIM.INPATIENT.UPLOADING_FILES'})}
                    </span>
                    <span
                      style={{
                        background: '#059BB6',
                        color: 'white',
                        borderRadius: '20px',
                        padding: '2px 10px',
                        fontSize: '14px',
                        fontWeight: 500,
                      }}
                    >
                      {uploadProgress}%
                    </span>
                  </div>
                  <div
                    style={{
                      background: '#f0f0f0',
                      borderRadius: '6px',
                      height: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        width: `${uploadProgress}%`,
                        height: '8px',
                        background: 'linear-gradient(90deg, #059BB6 0%, #05b6a6 100%)',
                        borderRadius: '4px',
                        transition: 'width 0.3s ease',
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Success Message */}
              {successMessage && (
                <div
                  style={{
                    marginBottom: '16px',
                    padding: '12px 16px',
                    background: '#d4edda',
                    color: '#155724',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 500,
                    boxShadow: '0 2px 6px rgba(21, 87, 36, 0.1)',
                  }}
                >
                  {successMessage}
                </div>
              )}

              {/* File List */}
              {selectedFiles.length > 0 && (
                <div className='selected-files mt-4'>
                  <h6 className='fw-bold mb-3'>{f({id: 'CLAIM.INPATIENT.SELECTED_FILES'})} </h6>
                  <div
                    style={{
                      maxHeight: '300px',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      borderRadius: '8px',
                      border: '1px solid #eee',
                      padding: '10px',
                    }}
                  >
                    {selectedFiles.map((file, index) => (
                      <div
                        key={index}
                        className='d-flex align-items-center justify-content-between p-3 bg-light rounded mb-2'
                        style={{
                          borderBottom:
                            index !== selectedFiles.length - 1 ? '1px solid #e9ecef' : 'none',
                        }}
                      >
                        <div className='d-flex align-items-center' style={{ overflow: 'hidden', flex: 1, marginRight: '10px' }}>
                          <i className='fas fa-file-alt fs-2 text-primary me-3 flex-shrink-0'></i>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            <span className='fw-bold d-block text-truncate'>{file.name}</span>
                            <span className='text-muted fs-7'>
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </span>
                          </div>
                        </div>
                        <div className='d-flex gap-2 flex-shrink-0'>
                          <button
                            type='button'
                            className='btn btn-icon btn-sm btn-light-primary'
                            onClick={() => {
                              const url = URL.createObjectURL(file)
                              window.open(url, '_blank')
                              setTimeout(() => URL.revokeObjectURL(url), 100)
                            }}
                            title={f({id: 'CLAIM.INPATIENT.DOCUMENT_PREVIEW'}) || 'Preview'}
                            style={{
                              width: '32px',
                              height: '32px',
                              padding: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <i className='fas fa-eye'></i>
                          </button>
                          <button
                            type='button'
                            className='btn btn-icon btn-sm btn-light-danger'
                            onClick={() => removeFile(index)}
                            style={{
                              width: '32px',
                              height: '32px',
                              padding: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <i className='fas fa-times'></i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Error Messages */}
              {fileErrors.length > 0 && (
                <div className='alert alert-danger mt-3'>
                  {fileErrors.map((error, index) => (
                    <div key={index} className='d-flex align-items-center'>
                      <i className='fas fa-exclamation-circle me-2'></i>
                      {error}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Step1 }
